// components/ui/Loader.tsx
import { cn } from "@/components/ui/utils"; // assuming you have cn utility

interface LoaderProps {
  size?: "sm" | "md" | "lg"; // small, medium, large
  className?: string;
  text?: string; // optional loading text
}

export default function Loader({
  size = "md",
  className,
  text = "Loading BINGOLD rewards...",
}: LoaderProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  }[size];

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4",
        className
      )}
    >
      {/* Main spinning ring with gradient */}
      <div className="relative">
        {/* Outer glow */}
        <div
          className={cn(
            "absolute inset-0 rounded-full bg-gradient-to-r from-yellow-500/30 to-amber-600/30 blur-xl animate-pulse",
            sizeClasses
          )}
        />

        {/* Main spinner */}
        <div
          className={cn(
            "relative rounded-full border-4 border-transparent animate-spin",
            sizeClasses,
            "bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-600",
            "shadow-[0_0_25px_rgba(234,179,8,0.6)]"
          )}
          style={{
            borderTopColor: "transparent",
            borderRightColor: "transparent",
            borderBottomColor: "transparent",
            borderLeftColor: "rgba(255,255,255,0.2)",
          }}
        />

        {/* Inner pulse */}
        <div
          className={cn(
            "absolute inset-2 rounded-full bg-gradient-to-br from-yellow-300/40 to-amber-600/40 animate-pulse",
            sizeClasses.replace("w-", "w-").replace("h-", "h-")
          )}
        />
      </div>

      {/* Optional loading text */}
      {text && (
        <p className="text-gray-300 text-sm md:text-base font-medium animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
}
